import React from 'react';
import { withRouter } from 'react-router';
import { Button } from 'app/components/Button';
import { ContactLink } from 'app/components/ContactLink';
import {
  AppBar,
  Grid,
  Hidden,
  Toolbar,
} from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Phone from '@material-ui/icons/Phone';
import { useTranslation } from 'react-i18next';
import { getImagePathSafely } from 'app/util/images';

export const HeaderComponent: any = ({ ...props }) => {
  const { logo, isRootRoute, isOnLoanOfficerSite, isSalesforce, hasContactUsLink, hasDisableLogoRedirect } = props;
  const { t }       = useTranslation();

  const imagePath = getImagePathSafely(logo);
  const imageStyles = {
    background: `url('${imagePath}') no-repeat center/contain`,
  };

  const renderLogo = () => {
    const logoImage = <Grid container style={imageStyles} classes={{ 'container': 'logo' }} />;
    if (isSalesforce) {
      // Removes the link from the logo for Servicing
      return logoImage;
    }
    // Links the logo to the root of site (WordPress or PQE homepage)
    return (
      <a href={hasDisableLogoRedirect ? undefined : window.location.origin} style={{ display: 'block' }} aria-label='Logo'>
        {logoImage}
      </a>
    );
  };
  return (
    (!isRootRoute || isOnLoanOfficerSite) && (
      <Grid container classes={{ container: 'headerWrapper' }}>
        <Grid item>
          <AppBar position="fixed" color="inherit" classes={{ root: 'header' }}>
            <Toolbar classes={{ regular: 'headerHeight' }}>
              <Grid container alignItems="center" classes={{ container: 'headerContainer' }}>
                <Grid item xs={4} classes={{ item: 'textLeft' }}>
                  {props.activeSection && !props.activeSection.hideBackButton ? (
                    <Hidden smUp>
                      <Button
                        classes = {{ root: 'leftHeaderButton' }}
                        color   = "primary"
                        onClick = {props.getPreviousSection}
                        size    = "small"
                        disableRipple
                      >
                        <ChevronLeft classes={{ root: 'alignChevronLeft' }} />{' '}
                        {t('button.branchHeader.back', { defaultValue: 'Back' })}
                      </Button>
                    </Hidden>
                  ) : (
                    <div>&nbsp;</div>
                  )}
                </Grid>
                <Grid item xs={4} classes={{ item: 'textCenter' }}>
                  {renderLogo()}
                </Grid>
                <Grid item xs={4} classes={{ item: 'textRight' }}>
                  {hasContactUsLink && !isOnLoanOfficerSite ? (
                    <ContactLink
                      buttonProps={{
                        classes       : { root: 'rightHeaderButton link' },
                        disableRipple : true,
                        size          : 'small',
                      }}
                    >
                      <Hidden smUp>
                        <Phone classes={{ root: 'phone' }} />
                      </Hidden>

                      <Hidden xsDown>
                        {t('global:button.header.contact', { defaultValue: 'Contact Us' })}
                      </Hidden>
                    </ContactLink>
                  ) : (
                    <div>&nbsp;</div>
                  )}
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </Grid>
      </Grid>
    )
  );
};

export const Header = (withRouter(HeaderComponent));
